module.exports = __webpack_public_path__ + "img/volume-off.2561ca61.svg";